import { AutogenModelPermsAllowDeny, AutogenRowPermsAllowDeny, RowPermsAllowDenyFields } from "./autogen/AutogenModelPermsAllowDeny";

export class ModelPermsAllowDeny extends AutogenModelPermsAllowDeny<RowPermsAllowDeny> {
    constructor() {
        super(RowPermsAllowDeny);
    }
}

export class RowPermsAllowDeny extends AutogenRowPermsAllowDeny {
    public static create(appending: boolean, data: Partial<RowPermsAllowDenyFields>): RowPermsAllowDeny {
        const row = new RowPermsAllowDeny();
        row._appending = appending;
        row.setValues(data);
        return row;
    }
}
